export const get = (
  object: Record<string, any>,
  path: string | any,
  value?: any
) => {
  const pathArray = Array.isArray(path)
    ? path
    : path.split(".").filter((key: string) => key);
  const pathArrayFlat = pathArray.flatMap((part: any) =>
    typeof part === "string" ? part.split(".") : part
  );
  const checkValue = pathArrayFlat.reduce(
    (obj: any, key: string) => obj && obj[key],
    object
  );
  return checkValue === undefined ? value : checkValue;
};
